import React, { useEffect, useState, useContext } from 'react';
import { useIntl } from 'react-intl';
import Loader from '~components/loader';
import Button from '~components/button';

const BottomNav = ({ 
  onFilterClick,
  isLoading,
  filters,
  defaultPreference = 0,
}) => {
    const intl = useIntl();
    const [filterCount, setFilterCount] = useState(0);
    useEffect(() => {
      // Start with 3 as default
      let count = defaultPreference;

      if (Array.isArray(filters?.languages)) {
        count += filters.languages.length;
      }
      if (Array.isArray(filters?.days)) {
        count += filters.days.length;
      }
      if (Array.isArray(filters?.attributes)) {
        count += filters.attributes.length;
      }
      
      setFilterCount(count);
    }, [filters]);

    return (
      <nav className="bottom-nav">
        <div className="c-modal__buttons">
          {isLoading ? (
            <div className="icon-loader">
              <Loader size="small" />
            </div>
          ): (
            <Button className="c-btn c-btn--wide" onClick={onFilterClick}>
              {intl.formatMessage({ id: 'components.bottom-bar.title', defaultMessage: 'Your preferences' })} ({filterCount})
            </Button>
          )}
        </div>
        
      </nav>
    );
};

export default BottomNav;

